import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UserLandingV2Item } from '../user-landings-v2-models';

@Component({
  selector: 'user-landings-content-modal',
  template: `
    <div>
      <label *ngIf="showLabel" class="eva-3-label-form -eva-3-mb-sm" for="input-width-label">{{textLabel}}</label>
      <div class="eva-3-input -lg">
        <div class="input-container">
          <input id="input-width-label" class="input-tag " type="text" placeholder="" maxlength="-1" autocomplete="off" [(ngModel)]="editedTitle" (ngModelChange)="handleTitleChange($event)" />
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./user-landings-content-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserLandingsContentModalComponent implements OnInit{
  @Input() title: string = '';
  @Input() showLabel: boolean = false;
  @Input() textLabel: string = '';
  @Output() titleChange = new EventEmitter<string>();

  editedTitle: string = '';

  ngOnInit(): void {
    this.editedTitle = this.title || '';
  }

  handleTitleChange(newTitle: string): void {
    this.titleChange.emit(newTitle);
  }
}
